import { collectionColumns, recording } from "@/mocks/homeMocks";

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-800",
  secondary: "bg-secondary-200/70 text-secondary-800",
};

export default function CollectionIndex() {
  return (
    <section id="archive" className="w-full bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-6 py-12 md:py-16">
        {/* 标题行 */}
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="flex items-center gap-2 text-xs tracking-[0.28em] text-foreground-500">
              <span className="inline-block h-px w-8 bg-primary-400"></span>
              索引 / 合集
            </p>
            <h2 className="font-heading mt-3 text-2xl md:text-4xl font-black tracking-tight text-foreground-950">
              按栏目翻实锤合集
            </h2>
            <p className="mt-3 max-w-xl text-sm md:text-base leading-7 text-foreground-600">
              黑料不只一个切面。合约、言行、时间轴、社媒痕迹各归各档，按图索骥找你想核的那一段。
            </p>
          </div>
          {/* 收录数据 */}
          <dl className="grid grid-cols-2 gap-x-6 gap-y-4 sm:grid-cols-4 md:gap-x-8">
            {recording.map((r) => (
              <div key={r.label} className="flex flex-col">
                <dd className="font-heading text-2xl font-black text-primary-600 md:text-3xl">
                  {r.value}
                </dd>
                <dt className="mt-1 text-xs tracking-wide text-foreground-500">{r.label}</dt>
              </div>
            ))}
          </dl>
        </div>

        {/* 栏目合集索引卡 */}
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3 md:gap-5">
          {collectionColumns.map((c) => (
            <a
              key={c.cat}
              href="#chain"
              className="group flex cursor-pointer flex-col rounded-xl border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300/70 md:p-6"
            >
              <div className="flex items-center justify-between">
                <span className={`flex h-9 w-9 items-center justify-center rounded-md ${toneMap[c.tone]}`}>
                  <i className="ri-folder-2-line text-lg" aria-hidden="true"></i>
                </span>
                <span className="font-heading text-2xl font-black text-background-300 transition-colors group-hover:text-primary-400">
                  {c.count}
                </span>
              </div>
              <h3 className="font-heading mt-5 text-lg font-bold text-foreground-950">
                {c.cat}
              </h3>
              <p className="mt-2 text-sm leading-6 text-foreground-500">{c.lead}</p>
              <span className="mt-5 flex items-center gap-1 text-sm font-medium text-primary-600">
                进合集
                <i
                  className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
                  aria-hidden="true"
                ></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}